import { LoadingButton } from '@mui/lab';
import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField
} from '@mui/material';
import axios from 'axios';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { HttpClient } from 'src/Helpers/http/http';
import { url } from 'src/Helpers/utils/Constant';
import Toaster from 'src/Toaster/Toaster';
import { IResponse } from 'src/basic-rest/types';
import MultipleAndSingleImgValidateWithPreview from 'src/common/FileValidation/MultipleAndSingleImgValidateWithPreview';
import { ISingleIdCard } from './types/idCardTypes';
type IProps = {
  singleIdCard: ISingleIdCard;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  setSingleIdCard: React.Dispatch<React.SetStateAction<ISingleIdCard>>;
};

const UpdateIdCard = ({
  singleIdCard,
  setShowModal,
  setSingleIdCard,
}: IProps) => {
  const Toast = Toaster();
  const { cardID } = useParams();
  const {
    register,
    handleSubmit,
    clearErrors,
    setError,
    formState: { errors, touchedFields },
    watch,
    getValues,
    reset,
  } = useForm<any>({
    defaultValues: {},
  });

  const isStatus = watch('blood_group');
  console.log(isStatus);
  useEffect(() => {
    reset({
      ...singleIdCard,
      date_of_birth: moment(singleIdCard?.date_of_birth).format('YYYY-MM-DD'),
    });
  }, [singleIdCard]);
  const [loading, setLoading] = useState(false);
  const onSubmit = async (value: any) => {
    console.log(value);
    const formData = new FormData();

    if (singleIdCard.user_member_id) {
      formData.append('user_member_id', String(singleIdCard.user_member_id));
    }
    if (singleIdCard.id) {
      formData.append('id', String(singleIdCard.id));
    }

    const touchedValues = Object?.keys(touchedFields)?.reduce(
      (acc, key) => {
        acc[key] = getValues(key);
        return acc;
      },
      {} as Record<string, any>
    );
    if (Object?.keys(touchedValues)?.length) {
      Object?.keys(touchedValues)?.forEach((key) => {
        if (
          touchedValues[key] instanceof FileList ||
          Array.isArray(touchedValues[key])
        ) {
          const file = touchedValues[key][0];
          if (file) {
            formData.append(key, file);
          }
        } else {
          formData.append(key, touchedValues[key]);
        }
      });

      try {
        const res: IResponse = await HttpClient.patch(
          `${url}/api/member/id-card/application`,
          formData
        );

        if (res.success) {
          Toaster().fire({
            icon: 'success',
            title: res.message,
          });
          const data = await axios.get(
            `${url}/api/member/id-card/application/${cardID}`
          );
          if (data?.data?.success) {
            setSingleIdCard(data.data.data);
          }
          setShowModal(false);
          reset({});
        }
      } catch (err: any) {
        Toaster().fire({
          icon: 'error',
          title: err?.response?.data.message,
        });
      }
    } else {
      Toast.fire({
        icon: 'error',
        title: `Change field first`,
      });
    }
  };

  return (
    <>
      <Box component='form' onSubmit={handleSubmit(onSubmit)} p={0}>
        <Grid container spacing={2} mb={2} maxWidth={'md'}>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Name of applicant'
              required
              id='outlined-required'
              type='text'
              {...register('applicant_name')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Designation'
              id='outlined-required'
              type='text'
              {...register('designation')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              required
              id='outlined-required'
              type='date'
              label='Date of birth'
              InputLabelProps={{
                shrink: true,
              }}
              {...register('date_of_birth')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <FormControl fullWidth>
              <InputLabel id='demo-simple-select-label'>Blood group</InputLabel>
              <Select
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                // value={bloodGroup}
                // onChange={(e) => setBloodGroup(e.target.value)}
                {...register('blood_group')}
                defaultValue={singleIdCard?.blood_group}
                label='Blood group'
              >
                <MenuItem value='a+'>A+</MenuItem>
                <MenuItem value='a-'>A-</MenuItem>
                <MenuItem value='ab+'>AB+</MenuItem>
                <MenuItem value='ab-'>AB-</MenuItem>
                <MenuItem value='b+'>B+</MenuItem>
                <MenuItem value='b-'>B-</MenuItem>
                <MenuItem value='o+'>O+</MenuItem>
                <MenuItem value='0-'>O-</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Telephone number'
              required
              id='outlined-required'
              type='text'
              {...register('telephone')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Cellphone number'
              required
              id='outlined-required'
              type='text'
              {...register('cellphone')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <TextField
              fullWidth
              label='Enter your email'
              required
              id='outlined-required'
              type='text'
              {...register('email')}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Photocopy of NID (Both side)'
              fieldName={`member_nid_file`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[singleIdCard.member_nid_file]}
            />
          </Grid>

          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='One copy passport size photography'
              fieldName={`photo`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[singleIdCard.photo]}
            />
          </Grid>
          <Grid xs={12} md={4} lg={4} item>
            <MultipleAndSingleImgValidateWithPreview
              mt={'0'}
              fileLimitSize={5}
              register={register}
              clearErrors={clearErrors}
              setError={setError}
              errors={errors}
              label='Signature with Seal'
              fieldName={`signature_file`}
              hideCustomLabel
              mode='single'
              imgSerUrl={[singleIdCard.signature_file]}
            />
          </Grid>
        </Grid>
        <Box component='form' onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <FormControl sx={{ width: '100%' }}>
                <InputLabel id='demo-simple-select-label'>
                  Select Status
                </InputLabel>
                <Select
                  {...register('status')}
                  labelId='demo-simple-select-label'
                  label='Ownership status'
                  defaultValue={singleIdCard?.status}
                >
                  <MenuItem value='pending'>Pending</MenuItem>
                  <MenuItem value='completed'>Completed</MenuItem>
                  <MenuItem value='rejected'>Rejected</MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Box>
        <Box mt={5}>
          {!loading ? (
            <Button
              type='submit'
              fullWidth
              variant='contained'
              disableElevation
            >
              Submit
            </Button>
          ) : (
            <LoadingButton
              loading
              loadingIndicator='Loading...'
              variant='contained'
              fullWidth
              disabled
            >
              <span>Loading...</span>
            </LoadingButton>
          )}
        </Box>
      </Box>
    </>
  );
};

export default UpdateIdCard;
